module.exports = __webpack_public_path__ + "static/media/32.721675de.mp3";